import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";

// After the (simulated) checkout: poll the payment state; credits appear only once the verified event is processed.
export function BillingReturn({ tid, onDone }) {
  const api = useApi();
  const [st, setSt] = useState(null);
  const sid = new URLSearchParams(window.location.search).get("billing");
  useEffect(() => {
    if (!sid) return undefined;
    if (sid === "cancelled") { setSt("cancelled"); return undefined; }
    let n = 0; let stop = false;
    const tickF = () => api.get(`/public/adm-billing/status/${sid}`).then(({ data }) => {
      setSt(data.status);
      if (["paid", "completed"].includes(data.status)) { onDone(); return; }
      if (!stop && n++ < 10) setTimeout(tickF, 2000);
    }).catch(() => setSt("unknown"));
    tickF();
    return () => { stop = true; };
  }, [api, sid, tid]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!st || st === "initiated") return undefined;
    const u = new URL(window.location.href); u.searchParams.delete("billing"); window.history.replaceState(null, "", u.toString());
    const h = setTimeout(() => setSt(null), 10000);  // one-off notice: never left stale above later changes
    return () => clearTimeout(h);
  }, [st]);
  if (!st) return null;
  const msg = { paid: "Pagamento registrato: crediti aggiunti al saldo.", completed: "Piano attivato: i crediti inclusi del mese sono nel saldo.",
    cancelled: "Pagamento annullato: nessun addebito.", initiated: "Pagamento in verifica…", failed: "Pagamento non riuscito.", unknown: "Stato del pagamento non disponibile." }[st] || st;
  const tone = ["paid", "completed"].includes(st) ? "border-emerald-200 bg-emerald-50 text-emerald-900" : st === "initiated" ? "border-sky-200 bg-sky-50 text-sky-900"
    : st === "cancelled" ? "border-amber-200 bg-amber-50 text-amber-900" : "border-red-200 bg-red-50 text-red-900";
  return <p className={`rounded-md border px-3 py-2 text-sm ${tone}`} data-testid="billing-return" data-status={st}>{msg}</p>;
}
